<template>
  <v-dialog
    v-model="shown"
    persistent
    :maximized="isMobile"
    max-width="1000"
  >
    <v-card class="pa-6">
      <v-row>
        <v-col>
          <h2>
            Določi veljavnost:
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="type !== 'day'">
        <v-col style="flex: 1;">
          <DateTimeSelector
            labelDate="Od"
            :date="dates.startDate"
            :time="dates.startTime"
            @change="({ date, time }) => updateStartDateTime({ date, time, i})"
          />
        </v-col>
      </v-row>
      <v-row v-if="type !== 'day'">
        <v-col style="flex: 1;">
          <DateTimeSelector
            labelDate="Do"
            :date="dates.endDate"
            :time="dates.endTime"
            @change="({ date, time }) => updateEndDateTime({ date, time, i })"
          />
        </v-col>
      </v-row>
      <v-row v-if="type === 'day'">
        <v-col cols="4">
          <v-select
            :items="daysOptions"
            item-text="name"
            item-value="val"
            v-model="days"
            label="Dnevi *"
            return-object
          >
          </v-select>
        </v-col>
        <v-col cols="4" style="flex: 1;">
          <DateTimeSelector
            ref="odTime"
            labelDate="Od"
            :date="dates.startDate"
            :time="dates.startTime"
            onlyTime="true"
            @change="({ date, time }) => updateStartDateTime({ date, time, i})"
          />
        </v-col>
        <v-col cols="4" style="flex: 1;">
          <DateTimeSelector
            ref="doTime"
            labelDate="Do"
            :date="dates.endDate"
            :time="dates.endTime"
            onlyTime="true"
            @change="({ date, time }) => updateEndDateTime({ date, time, i })"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn v-if="!skrij" class="float-right white--text" color="#0F998E" @click="confirm">
            Dodaj
          </v-btn>
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
import { mapGetters } from 'vuex'
import DateTimeSelector from '@/components/DateTimeSelector.vue'
export default {
  components: {
    DateTimeSelector,
  },
  props: {
    title: {
      required: true,
      type: String
    },
    text: {
      required: true,
      type: String
    },
    okBtnText: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Boolean
    },
    normal: {
      default: true,
      required: false,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  data () {
    return {
      daysOptions: [
        {
          name: 'ponedeljek',
          val: 1,
        },
        {
          name: 'torek',
          val: 2,
        },
        {
          name: 'sreda',
          val: 3,
        },
        {
          name: 'četrtek',
          val: 4,
        },
        {
          name: 'petek',
          val: 5,
        },
        {
          name: 'sobota',
          val: 6,
        },
        {
          name: 'nedelja',
          val: 7
        }
      ],
      dates: {
        startDate: moment().format('YYYY-MM-DD'),
        startTime: '00:00',
        endDate: moment().format('YYYY-MM-DD'),
        endTime: '23:59',
      },
      days: [],
      type: 'date',
      shown: false,
    }
  },
  methods: {
    updateStartDateTime ({ date, time, i }) {
      this.dates.startDate = date
      this.dates.startTime = time
    },
    updateEndDateTime ({ date, time, i }) {
      this.dates.endDate = date
      this.dates.endTime = time
    },
    open (type) {
      /* if (datesInfo) {
        this.dates = datesInfo
      } */
      if (this.$refs.odTime && this.$refs.doTime) {
        this.$refs.odTime.resetTime('00:00')
        this.$refs.doTime.resetTime('23:59')
      }
      this.dates.startDate = moment().format('YYYY-MM-DD')
      this.dates.startTime = '00:00'
      this.dates.endDate = moment().format('YYYY-MM-DD')
      this.dates.endTime = '23:59'

      this.days = []
      if (type) {
        this.type = type
      }
      this.shown = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm () {
      this.shown = false
      this.resolve({
        dates: this.dates,
        days: this.days,
        typeDialog: this.type
      })
    },
    cancel () {
      this.shown = false
      this.resolve(false)
    },
  },
  watch: {
  }
}
</script>
